export default {
  namespaced: true,
  state: {
    message: null,
    success: true,
    loading: 0,
    counter: 0,
    queueData: {},
    fields: {},
  },
  mutations: {
    loading(state, input) { state.loading = input; },
    reportWarning(state, text) { state.message = { warning: true, success: false, text }; },
    reportSaved(state) { state.message = { success: true, message: 'saved' }; },
    reportInserted(state) { state.message = { success: true, message: 'inserted' }; },
    reportClear(state) { state.message = null; },
    success(state) {
      state.success = true;
    },
    fail(state, input) {
      state.success = false;
      state.message = input;
    },
    loaded(state, input) {
      const { entity, primary } = input;
      let { data } = input;
      if (!Array.isArray(data)) data = [data];
      if (!state.queueData[entity]) state.queueData[entity] = {};
      for (let i = 0; i < data.length; i++) {
        const index = primary ? data[i][primary] : i;
        state.queueData[entity][index] = data[i];
      }
      state.counter -= 1;
    },
  },
};
